import { Button, Dialog, Grid, CircularProgress, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import CustomDialogTitle from '../../../projectsDashboard/CustomDialogTitle';
import BatchDetailsUnitBox from '../viewProcessInformation/BatchDetailsUnitBox';
import ExceptionDetails from '../viewBatchQualityEvents/ExceptionDetails';
import ViewStructuredInformation from '../ViewStructuredInformation';
import { useDispatch } from 'react-redux';
import {
  fetchDSBatchDetails,
  syncPOFromSAP,
  syncInventoryFromSAP
} from '../../../../../containers/actions/common/saslAction';
import ViewRmPMLots from './../ViewRMPMLots/index'
import StyledDialog from '../../../../../../common/models/Dialog';

export const ViewBatchPageButtons = (props) => {
  const dispatch = useDispatch()

  const { batchDetails, view, schrockenDeliveryScheduleID, featureAccess, targetQuantity, cmoBatchNumber,consumptionSameAsAllocation } = props

  const [syncPoLoading, setSyncPoLoading] = useState(false);
  const [syncInventoryLoading, setSyncInventoryLoading] = useState(false);
  const [syncResultDialog, setSyncResultDialog] = useState({
    open: false,
    success: false,
    title: '',
    message: ''
  });

  // Helpers: build ISO date strings "YYYY-MM-DDTHH:mm:ssZ" (no ms) as required by both APIs
  // startOfDay → 00:00:00Z,  endOfDay → 23:59:59Z
  const toISODate = (d) => new Date(d).toISOString().slice(0, 10); // "YYYY-MM-DD"
  const startOfDay = (d) => `${toISODate(d)}T00:00:00Z`;
  const endOfDay   = (d) => `${toISODate(d)}T23:59:59Z`;

  const handleSyncPO = async () => {
    setSyncPoLoading(true);
    try {
      // /updateSASLDSDataNew — date format: YYYY-MM-DDTHH:mm:ssZ
      // Date range: from SA creationDate (comes directly in batchDetails) to today.
      const today = new Date();
      // Slice date part directly from the ISO string to avoid timezone shift issues.
      // "2026-04-14T17:20:09.971" → "2026-04-14" — no Date() conversion needed.
      const poStartDate = batchDetails.agreementDate.slice(0, 10);
      const payload = {
        dateRanges: [{ startDate: `${poStartDate}T00:00:00Z`, endDate: endOfDay(today) }],
        vendorNumber: batchDetails?.vendorNumber ? [batchDetails.vendorNumber] : [],
        vendorPlant: batchDetails?.vendorPlant ? [batchDetails.vendorPlant] : [],
        poNumber: batchDetails?.scheduleAgreementNumber ? [batchDetails.scheduleAgreementNumber] : []
      };
      const result = await dispatch(syncPOFromSAP(payload));
      setSyncResultDialog({
        open: true,
        success: result?.success === true,
        title: result?.success ? 'PO Synced Successfully' : 'Sync PO Failed',
        message: result?.success
          ? 'Purchase Order data has been synced from SAP successfully.'
          : (result?.message || 'An error occurred while syncing PO data.')
      });
    } catch (err) {
      setSyncResultDialog({
        open: true,
        success: false,
        title: 'Sync PO Failed',
        message: err?.response?.data?.message || err?.response?.data?.error || err?.message || 'An error occurred while syncing PO data.'
      });
    } finally {
      setSyncPoLoading(false);
    }
  };

  const handleSyncInventory = async () => {
    setSyncInventoryLoading(true);
    try {
      // /syncInventoryDataNew — date format: YYYY-MM-DDTHH:mm:ssZ
      // Date range: 1 year back to today.
      // materialNumber: RM/PM component material codes (BomComponentCode) from bomConsumptionDetails.
      // inventoryBatchNumber: RM/PM component batch/lot numbers from bomConsumptionDetails.
      const today = new Date();
      const past  = new Date(today);
      past.setFullYear(past.getFullYear() - 1);
      const materialNumbers = [];
      (batchDetails?.bomComponentDetails || []).forEach(comp => {
        // Material number of each RM/PM component
        if (comp.BomComponentCode) materialNumbers.push(comp.BomComponentCode);
      });
      console.log('materialNumbers', materialNumbers)
      const payload = {
        dateRanges: [{ startDate: startOfDay(past), endDate: endOfDay(today) }],
        vendorNumber: batchDetails?.vendorNumber ? [batchDetails.vendorNumber] : [],
        vendorPlant: batchDetails?.vendorPlant ? [batchDetails.vendorPlant] : [],
        materialNumber: materialNumbers,
        // inventoryBatchNumber is kept in the payload but always empty — sync stays
        // at material + date-range level (no batch scoping), even when lots exist.
        inventoryBatchNumber: [],
        // /syncInventoryDataNew requires snapshot ('S' full snapshot / 'D' delta)
        // and zeroStockLines ('Y'/'N'); send them so the sync passes validation.
        snapshot: "S",
        zeroStockLines: "N",
      };
      const result = await dispatch(syncInventoryFromSAP(payload));
      setSyncResultDialog({
        open: true,
        success: result?.success === true,
        title: result?.success ? 'Inventory Synced Successfully' : 'Sync Inventory Failed',
        message: result?.success
          ? 'Inventory data has been synced from SAP successfully.'
          : (result?.message || 'An error occurred while syncing inventory data.')
      });
    } catch (err) {
      setSyncResultDialog({
        open: true,
        success: false,
        title: 'Sync Inventory Failed',
        message: err?.response?.data?.message || err?.response?.data?.error || err?.message || 'An error occurred while syncing inventory data.'
      });
    } finally {
      setSyncInventoryLoading(false);
    }
  };

  const [openDialogBox, setDialogBox] = useState({
    viewProcessInformation: false,
    viewQualityEvents: false,
    viewStructuredInformation: false,
    viewRMPMLots: false,
  })

  const handleOpenCloseDialogBox = (type) => {
    if (type === 'viewProcessInformation') {
      setDialogBox({
        viewProcessInformation: !openDialogBox.viewProcessInformation,
        viewQualityEvents: false,
        viewStructuredInformation: false,
      })
    } else if (type === 'viewQualityEvents') {
      setDialogBox({
        viewProcessInformation: false,
        viewQualityEvents: !openDialogBox.viewQualityEvents,
        viewStructuredInformation: false,
      })
    } else if (type === 'viewStructuredInformation') {
      setDialogBox({
        viewProcessInformation: false,
        viewQualityEvents: false,
        viewStructuredInformation: !openDialogBox.viewStructuredInformation,
      })
      if (openDialogBox.viewStructuredInformation) {
        let data1 = {
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          //cmoBatchNumber: cmoBatchNumber,
        };
        dispatch(fetchDSBatchDetails(data1));
      }

    } else if (type === 'viewRMPMLots') {
      setDialogBox({
        ...openDialogBox,
        viewRMPMLots: !openDialogBox.viewRMPMLots,
      })
      if (openDialogBox.viewRMPMLots) {
        let data1 = {
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          //cmoBatchNumber: cmoBatchNumber,
        };
        dispatch(fetchDSBatchDetails(data1));
      }
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        {/* {featureAccess?.fgBatchViewProcessInformation &&
        <Grid item>
          <Button style={{textTransform:'none'}} variant="contained" color="secondary" onClick={()=>handleOpenCloseDialogBox('viewProcessInformation')}>
            View process information
          </Button>
        </Grid>
        } */}

        {/* {featureAccess?.fgBatchViewQualityEvents &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewQualityEvents')}>
              View quality events
            </Button>
          </Grid>
        } */}

        {featureAccess?.fgBatchViewDigitizedInformation &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewStructuredInformation')}>
              View Digitalized Information
            </Button>
          </Grid>
        }

        {featureAccess?.viewGoodsReceipt &&
          <Grid item>
            <Button style={{ textTransform: 'none' }} variant="contained" color="secondary" onClick={() => handleOpenCloseDialogBox('viewRMPMLots')}>
              {/* View RM/PM lots (Planned and actual) */}
              View Goods Receipt and Consumption Validation
            </Button>
          </Grid>
        }

      </Grid>
      <Dialog open={openDialogBox.viewProcessInformation} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewProcessInformation')}
          title={'View process information'}
        />
        <BatchDetailsUnitBox batchDetails={batchDetails} view={view} featureAccess={featureAccess} />
      </Dialog>


      <Dialog open={openDialogBox.viewQualityEvents} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewQualityEvents')}
          title={'View quality events'}
        />
        <ExceptionDetails batchDetails={batchDetails} featureAccess={featureAccess} />
      </Dialog>

      <Dialog open={openDialogBox.viewStructuredInformation} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewStructuredInformation')}
          title={'View Digitalized Information'}
          rightContent={
            (featureAccess?.syncPO || featureAccess?.syncInventory) ? (
              <>
                {featureAccess?.syncPO && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSyncPO}
                    disabled={syncPoLoading || syncInventoryLoading}
                    style={{ textTransform: 'none', minWidth: 100 }}
                  >
                    {syncPoLoading ? <CircularProgress size={16} style={{ marginRight: 6 }} /> : null}
                    Sync PO
                  </Button>
                )}
                {featureAccess?.syncInventory && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSyncInventory}
                    disabled={syncPoLoading || syncInventoryLoading}
                    style={{ textTransform: 'none', minWidth: 130 }}
                  >
                    {syncInventoryLoading ? <CircularProgress size={16} style={{ marginRight: 6 }} /> : null}
                    Sync Inventory
                  </Button>
                )}
              </>
            ) : null
          }
        />
        <ViewStructuredInformation
          batchDetails={batchDetails}
          schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
          cmoBatchNumber={cmoBatchNumber}
          featureAccess={featureAccess}
          targetQuantity={targetQuantity}
          consumptionSameAsAllocation={consumptionSameAsAllocation}
        />
      </Dialog>

      <Dialog open={openDialogBox.viewRMPMLots} fullScreen>
        <CustomDialogTitle
          onBackClick={() => handleOpenCloseDialogBox('viewRMPMLots')}
          // title={'View RM/PM lots (Planned and actual)'}
          title={'View Goods Receipt and Consumption Validation'}
        />
        <ViewRmPMLots batchDetails={batchDetails}
          selectedDeliveryBatchID={batchDetails?.schrockenDeliveryScheduleBatchID}
          targetQuantity={targetQuantity}
          cmoBatchNumber={cmoBatchNumber}
          onDataRefresh={() => {
            let data1 = {
              schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
              //cmoBatchNumber: cmoBatchNumber,
            };
            dispatch(fetchDSBatchDetails(data1));
          }}
        />
      </Dialog>

      {/* BCM-564: Sync PO / Sync Inventory — success dialog (uses app-wide StyledDialog) */}
      <Dialog
        open={syncResultDialog.open && syncResultDialog.success}
        onClose={() => setSyncResultDialog({ open: false, success: false, title: '', message: '' })}
        fullWidth
        maxWidth="xs"
      >
        <StyledDialog
          icons={true}
          title={syncResultDialog.title}
          handleClose={() => setSyncResultDialog({ open: false, success: false, title: '', message: '' })}
        />
      </Dialog>

      {/* BCM-564: Sync PO / Sync Inventory — error dialog */}
      <Dialog
        open={syncResultDialog.open && !syncResultDialog.success}
        onClose={() => setSyncResultDialog({ open: false, success: false, title: '', message: '' })}
        fullWidth
        maxWidth="xs"
        PaperProps={{ style: { borderRadius: 12, padding: '2rem 1.5rem', textAlign: 'center' } }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            backgroundColor: '#e53935',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <span style={{ color: 'white', fontSize: 36, lineHeight: 1 }}>✕</span>
          </div>
          <Typography variant="h6" style={{ fontWeight: 700, margin: 0 }}>
            {syncResultDialog.title}
          </Typography>
          {syncResultDialog.message && (
            <Typography variant="body2" style={{ color: '#555' }}>
              {syncResultDialog.message}
            </Typography>
          )}
          <Button
            onClick={() => setSyncResultDialog({ open: false, success: false, title: '', message: '' })}
            style={{
              textTransform: 'none', minWidth: 90,
              backgroundColor: '#e65100', color: 'white',
              borderRadius: 20, fontWeight: 600, padding: '6px 24px',
            }}
          >
            Ok
          </Button>
        </div>
      </Dialog>

    </React.Fragment>
  );
};
